import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import AuthNavbar from "../components/AuthNavbar/AuthNavbar";

function Layout() {


  return (

    <div style={{ display: "flex", height: "100vh" }}>

      <div className="normalQuery">
        <Sidebar />
      </div>
      <div style={{ flex: 1, height: "100vh", overflowY: "scroll" }}>
        <AuthNavbar />

        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
